var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "chevronDown_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chevronDown_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M8 9.967a.7.7 0 0 1-.25-.042.6.6 0 0 1-.217-.142L4.45 6.7a.6.6 0 0 1-.175-.459.65.65 0 0 1 .192-.458.63.63 0 0 1 .466-.183q.284 0 .467.183l2.6 2.6 2.617-2.616a.6.6 0 0 1 .458-.176q.275.009.458.192a.63.63 0 0 1 .184.467.63.63 0 0 1-.184.467L8.467 9.783a.6.6 0 0 1-.217.142.7.7 0 0 1-.25.042"
  }))));
};
export default SvgChevronDown;